<template>
    <v-dialog
            v-model="cameraNeededDialog"
            hide-overlay
            persistent
            width="300"
    >
        <v-card
                color=""
        >
            <v-toolbar dark color="primary lighten-1">
                <v-toolbar-title>Achtung</v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
                <p>Diese Anwendung benötigt ein Endgerät mit Kamera, damit die Gegenstände fotografiert werden können.</p>
                <p>Ein Abschluss ohne Produktfotos ist leider nicht möglich!</p>
                <p>Ihr Berater vor Ort hilft Ihnen aber gerne weiter. Vielen Dank für Ihr Verständnis!</p>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name: "DialogNoCamNoFun",
        data(){
            return {
                cameraNeededDialog: (!this.$store.state.camera)
            }
        }
    }
</script>

<style scoped>

</style>
